import axiosInstance from "../../services/axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/chat";

// Function to fetch the user ID from the backend
export async function fetchUserId() {
  // Make a GET request to the backend to fetch user metadata
  const response = await instance.get("/user/get_user_metadata");
  return response.data;
}

// Function to start a new chat session
export async function startChat(
  searchType,
  proposal_id,
  purpose,
  files = [],
  force = false
) {
  if (!proposal_id) {
    return null;
  }
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  formData.append("proposal_id", proposal_id);
  formData.append("search_type", searchType);
  formData.append("purpose", purpose);
  formData.append("force", force);

  const response = await instance.post(`/start-chat`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 200000,
  });

  return response.data;
}

export async function startChatIds(
  search_type,
  proposal_id,
  purpose,
  doc_ids = []
) {
  if (!proposal_id) {
    return null;
  }

  const response = await instance.post(
    `/start-chat-ids`,
    { search_type, proposal_id, purpose, doc_ids },
    {
      timeout: 200000,
    }
  );

  return response.data;
}

// Function to upload documents
export async function uploadDocuments(userId, files) {
  // Create a new FormData object to hold the files and user ID
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }
  formData.append("user_id", userId);

  try {
    // Make a POST request to upload the documents
    await instance.post("/upload_documents", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    alert("Files uploaded successfully.");
  } catch (error) {
    // Log any errors that occur during the request
    console.error("Error uploading documents:", error);
    throw error;
  }
}
